import { render, staticRenderFns } from "./SVGSunBlack.vue?vue&type=template&id=714f65ca&scoped=true&"
import script from "./SVGSunBlack.vue?vue&type=script&lang=js&"
export * from "./SVGSunBlack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714f65ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('714f65ca')) {
      api.createRecord('714f65ca', component.options)
    } else {
      api.reload('714f65ca', component.options)
    }
    module.hot.accept("./SVGSunBlack.vue?vue&type=template&id=714f65ca&scoped=true&", function () {
      api.rerender('714f65ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGSunBlack.vue"
export default component.exports